import { RateLocationMapper } from "../rate-location/rate-location.mapper";
import { RateLocation } from "../rate-location/rate-location.type";
import { RateSurchargeBase } from "./rate-surcharge-base.model";
import { SurchargeType } from "../../surcharge-type/surcharge-type.model";
import { SurchargeTypeMapper } from "../../surcharge-type/surcharge-type.mapper";

export class LclRateSurcharge extends RateSurchargeBase {
  constructor(
    protected id: number,
    protected discriminator: string,
    protected surchargeType: SurchargeType,
    protected rateOriginLocations: RateLocation[],
    protected rateDestinationLocations: RateLocation[],
    protected wmPrice: number,
    protected blPrice: number,
    protected minPrice: number,
  ) {
    super(
      id,
      discriminator,
      surchargeType,
      rateOriginLocations,
      rateDestinationLocations,
    );
  }

  public getWmPrice(): number {
    return this.wmPrice;
  }

  public getBlPrice(): number {
    return this.blPrice;
  }

  public getMinPrice(): number {
    return this.minPrice;
  }

  public getClone(): LclRateSurcharge {
    return new LclRateSurcharge(
      this.getId(),
      this.getDiscriminator(),
      SurchargeTypeMapper.map(this.getSurchargeType()),
      this.getRateOriginLocations()
        ? this.getRateOriginLocations().map(RateLocationMapper.map)
        : [],
      this.getRateDestinationLocations()
        ? this.getRateDestinationLocations().map(RateLocationMapper.map)
        : [],
      this.getWmPrice(),
      this.getBlPrice(),
      this.getMinPrice(),
    );
  }
}
